import styled from 'styled-components';

export const Main = styled.main`
    padding: 175px 16.66666666666667% 359px;
`;
